import { useEffect, useState } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';

import { getQueryParams } from '@src/helpers/helpers';

export type TAlertStatus = 'success' | 'failure' | 'cancel' | null;

export const useTrueLayerRedirected = () => {
    const [alertStatus, setAlertStatus] = useState<TAlertStatus>(null);

    const params = getQueryParams();

    useEffect(() => {
        if (
            params &&
            params.status_code &&
            params.referer === 'truelayer_callback'
        ) {
            if (params.status_code === '200') {
                tracking.ampli.openBankingLinkedSuccessfully();
                setAlertStatus('success');
            }
            if (
                params.status_code === '500' &&
                params.error_detail &&
                params.error_detail === 'access_denied'
            ) {
                tracking.ampli.openBankingLinkingCancelled();
                setAlertStatus('cancel');
            }
            if (
                params.status_code === '500' &&
                params.error_detail !== 'access_denied'
            ) {
                tracking.ampli.openBankingLinkingFailed();
                setAlertStatus('failure');
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        alertStatus
    };
};
